import { useState } from 'react';
import { AccountCircleOutlined as AccountCircleOutlinedIcon } from '@mui/icons-material';
import { Avatar, Box, BoxProps, IconButton } from '@mui/material';
import { UserMenu } from './UserMenu';

const avatarStyles = { width: 40, height: 40 };

const menuListProps = {
    'aria-labelledby': 'user-menu-button',
};

interface Props extends BoxProps {
    avatar: string;
}

export const MyProfile = ({ avatar, ...boxProps }: Props) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box {...boxProps}>
            <IconButton onClick={handleClick}>
                <Avatar sx={avatarStyles} src={avatar}>
                    <AccountCircleOutlinedIcon />
                </Avatar>
            </IconButton>
            <UserMenu
                id="user-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onMenuClose={handleClose}
                MenuListProps={menuListProps}
            />
        </Box>
    );
};
